import {create} from 'zustand';
import {reportApi} from '../services/api/reportApi';

export const useReportStore = create((set) => ({
  dashboard: null,
  insights: null,
  monthlyData: null,
  sales: null,
  payments: null,
  dues: null,
  isLoading: false,

  fetchDashboard: async (from, to, orgUnitId) => {
    set({isLoading: true});
    try {
      const response = await reportApi.getDashboard(from, to, orgUnitId);
      set({dashboard: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },

  fetchInsights: async (from, to, orgUnitId) => {
    set({isLoading: true});
    try {
      const response = await reportApi.getInsights(from, to, orgUnitId);
      set({insights: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },

  fetchMonthlyData: async (year, orgUnitId) => {
    set({isLoading: true});
    try {
      const response = await reportApi.getMonthlyData(year, orgUnitId);
      set({monthlyData: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },

  fetchSales: async (from, to, orgUnitId) => {
    set({isLoading: true});
    try {
      const response = await reportApi.getSales(from, to, orgUnitId);
      set({sales: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },

  fetchPayments: async (from, to, orgUnitId) => {
    set({isLoading: true});
    try {
      const response = await reportApi.getPayments(from, to, orgUnitId);
      set({payments: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },

  fetchDues: async (from, to, statuses, orgUnitId) => {
    set({isLoading: true});
    try {
      const response = await reportApi.getDues(from, to, statuses, orgUnitId);
      set({dues: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },
}));
